import React, { createContext, useState, useContext, useEffect } from "react";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [studentUser, setStudentUser] = useState(() => {
    const saved = localStorage.getItem("studentUser");
    return saved ? JSON.parse(saved) : null;
  });
  const [facultyUser, setFacultyUser] = useState(() => {
    const saved = localStorage.getItem("facultyUser");
    return saved ? JSON.parse(saved) : null;
  });
  const [adminUser, setAdminUser] = useState(() => {
    const saved = localStorage.getItem("adminUser");
    return saved ? JSON.parse(saved) : null;
  });

  // ✅ Save to localStorage on change
  useEffect(() => {
    if (studentUser) localStorage.setItem("studentUser", JSON.stringify(studentUser));
    else localStorage.removeItem("studentUser");

    if (facultyUser) localStorage.setItem("facultyUser", JSON.stringify(facultyUser));
    else localStorage.removeItem("facultyUser");

    if (adminUser) localStorage.setItem("adminUser", JSON.stringify(adminUser));
    else localStorage.removeItem("adminUser");
  }, [studentUser, facultyUser, adminUser]);

  // Login/Logout functions
  const loginStudent = (data) => setStudentUser(data);
  const logoutStudent = () => setStudentUser(null);

  const loginFaculty = (data) => setFacultyUser(data);
  const logoutFaculty = () => setFacultyUser(null);

  const loginAdmin = (data) => setAdminUser(data);
  const logoutAdmin = () => setAdminUser(null);

  return (
    <AuthContext.Provider
      value={{
        studentUser,
        facultyUser,
        adminUser,
        loginStudent,
        loginFaculty,
        loginAdmin,
        logoutStudent,
        logoutFaculty,
        logoutAdmin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
